import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { RegistrationService } from 'projects/services/src/app/API/registration.service';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';
import { ValidationService } from 'projects/services/src/app/validation.service';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { StorageService } from 'projects/services/src/app/storage.service';
import { LoginService } from 'projects/services/src/app/API/login/login.service';
declare var swal: any;

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
  passwordResetForm: FormGroup;
  updatePasswordForm: FormGroup;
  verifyOTPForm: FormGroup;
  token;
  showPassword = false;
  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private location: Location,
    private registrationService: RegistrationService,
    private loginService: LoginService,
    private storageService: StorageService,
    private currentUserService: CurrentUserService) {

    this.updatePasswordForm = this.formBuilder.group(
      {
        'password': ['', Validators.compose([Validators.required, Validators.minLength(8),
        Validators.maxLength(16), ValidationService.passwordValidator])],
        'confirmPassword': [null, Validators.compose([Validators.required, Validators.minLength(8), Validators.maxLength(16)])],
      });

    this.verifyOTPForm = this.formBuilder.group(
      {
        'mobileOTP': ['', [Validators.pattern('[0-9]{6}'), Validators.maxLength(6)]],
        'emailOTP': ['', [Validators.pattern('[0-9]{6}'), Validators.maxLength(6)]]
      });
  }

  ngOnInit() {
    this.token = this.currentUserService.decodeToken();
  }

  sendOTP() {
    if (this.updatePasswordForm.invalid) {
      Helpers.markFormGroupTouched(this.updatePasswordForm);
      return;
    }
    this.registrationService.generateOTPForForgotPassword(this.token.userName).subscribe(res => {
      Helpers.openModal('verify-otp');
    })
  }

  async setPassword() {
    const publicKey = await this.loginService.getPublicKey().toPromise();
		console.log(publicKey.publicKey);
    const password = await this.loginService.encryptPassword(publicKey.publicKey, this.updatePasswordForm.value.password,publicKey.secret);
    const confirmPassword = await this.loginService.encryptPassword(publicKey.publicKey, this.updatePasswordForm.value.confirmPassword,publicKey.secret);
	
		const setPasswordDetails = {
			phoneOtp: this.verifyOTPForm.get('mobileOTP').value,
      emailOtp: this.verifyOTPForm.get('emailOTP').value,
			userID: this.token.userName,
			// password: btoa(this.updatePasswordForm.value.password),
			// confirmPassword: btoa(this.updatePasswordForm.value.confirmPassword),
			password: password,
			confirmPassword: confirmPassword,
    };
		this.registrationService.setForgotPassword(setPasswordDetails)
			.subscribe(res => {
        swal('Password is updated Successfully');
        Helpers.closeModal('verify-otp')
        this.logout();
			});
  }

  logout() {
    const cred = {
      userName: this.token.userName
    };
    this.loginService.logout(cred).subscribe(res => {
      this.router.navigate(['/login']);
      this.storageService.removeAll();
      this.currentUserService.SetCurrentUserOnLogout();
    }, err => {
      this.router.navigate(['/login']);
      this.storageService.removeAll();
      this.currentUserService.SetCurrentUserOnLogout();
    }
    );
}
  back() {
    this.location.back();
  }
  get validOTP() {
    if ((!!this.verifyOTPForm.get('mobileOTP').value || !!this.verifyOTPForm.get('emailOTP').value)) {
      if (!!this.verifyOTPForm.get('mobileOTP').value) {
        return !!this.verifyOTPForm.get('mobileOTP').valid;
      } else {
        return !!this.verifyOTPForm.get('emailOTP').valid;
      }
    }
  }
  showPassClick() {
    this.showPassword =  !this.showPassword
  }
}
